module.exports = __webpack_public_path__ + "img/8626cb8.jpg";